var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "core-js/modules/es6.array.fill", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "react", "prop-types", "../SingleLineSlider/SingleLineSlider"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("core-js/modules/es6.array.fill"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("react"), require("prop-types"), require("../SingleLineSlider/SingleLineSlider"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.es6Array, global.classCallCheck, global.createClass, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.react, global.propTypes, global.SingleLineSlider);
    global.LandscapeSlider = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _es6Array, _classCallCheck2, _createClass2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _react, _propTypes, _SingleLineSlider) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _SingleLineSlider = _interopRequireDefault(_SingleLineSlider);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var LandscapeSlider = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(LandscapeSlider, _PureComponent);

    var _super = _createSuper(LandscapeSlider);

    function LandscapeSlider() {
      (0, _classCallCheck2.default)(this, LandscapeSlider);
      return _super.apply(this, arguments);
    }

    (0, _createClass2.default)(LandscapeSlider, [{
      key: "getTeasers",
      value: function getTeasers() {
        var _this = this;

        return this.props.placeholders > 0 ? Array(this.props.placeholders).fill(0).map(function (value, index) {
          return {
            duration: 1,
            id: "placeholder-".concat(index),
            images: [],
            kind: _this.props.placeholderKind,
            labels: {
              durationUnit: '-'
            },
            placeholder: true,
            title: '-',
            url: ''
          };
        }) : this.props.teasers;
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react.default.createElement(_SingleLineSlider.default, {
          kind: this.props.kind,
          placeholders: this.props.placeholders,
          teasers: this.getTeasers(),
          theme: this.props.theme,
          themeName: this.props.themeName,
          fetch: this.props.fetch
        });
      }
    }]);
    return LandscapeSlider;
  }(_react.PureComponent);

  LandscapeSlider.propTypes = {
    kind: _propTypes.default.string,
    placeholderKind: _propTypes.default.string,
    placeholders: _propTypes.default.number,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    theme: _propTypes.default.string,
    themeName: _propTypes.default.string,
    fetch: _propTypes.default.func
  };
  LandscapeSlider.defaultProps = {
    kind: 'LANDSCAPE',
    placeholderKind: '',
    placeholders: 0,
    teasers: [],
    theme: 'next',
    themeName: ''
  };
  var _default = LandscapeSlider;
  _exports.default = _default;
});